<template>
  <div class="main-header">
    <a-dropdown placement="bottomRight" v-if="token">
      <div class="account-avatar">
        <a-avatar class="avatar" icon="user" />
        <span>admin</span>
      </div>
      <template slot="overlay">
        <a-menu>
          <a-menu-item @click="handleLogoutClick">
            <a-icon type="logout" />
            退出登录
          </a-menu-item>
        </a-menu>
      </template>
    </a-dropdown>
  </div>
</template>

<script>
import { Modal } from 'ant-design-vue';
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'MainHeader',

  computed: {
    ...mapState('user', ['info', 'token']),
    ...mapGetters('user', ['infoIsReady']),
  },

  methods: {
    handleLogoutClick() {
      Modal.confirm({
        title: '提示',
        content: '确认退出登录吗？',
        confirmLoading: this.confirmLoading,
        onOk: () => {
          return this.$store.dispatch('user/logout').then(() => {
            this.$router.push({ name: this.$routeName.login });
          });
        },
      });
    },
  },
};
</script>

<style scoped lang="less">
.main-header {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 100%;
}

.account-avatar {
  padding: 0 12px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.3s;
  height: 100%;
  min-width: 120px;

  &:hover {
    background-color: rgba(0, 0, 0, 0.025);
  }

  .avatar {
    margin-right: 8px;
  }
}
</style>
